export const cardImage = () => ({
  height: 350,
  objectFit: 'cover'
});
